<template>
  <keep-alive>
    <div class="hero-simple">
      <Heading v-if="title" :level="1" :content="title" class="title" />
      <Paragraph v-if="description" :content="description" class="description" />
    </div>
  </keep-alive>
</template>

<script setup lang="ts">
interface IProps {
  title?: string | null;
  description?: string | null;
}

defineProps<IProps>();
</script>

<style scoped lang="postcss">
.hero-simple {
  display: flex;
  flex-direction: column;

  --margin-top: var(--unit-16);
  --gap: var(--unit-8);

  margin-top: var(--margin-top);
  gap: var(--gap);

  @media (--lg-viewport) {
    --margin-top: var(--unit-24);
    --gap: var(--unit-16);
  }

  .title {
    @mixin heading-3xl {
    }
    color: hsl(var(--color-primary-950));
  }

  .description {
    @mixin body-md {
    }

    color: hsl(var(--color-primary-900));

    @media (--lg-viewport) {
      padding-right: 176px;
    }
  }

  /* offsets the grid gap */
  margin-bottom: -16px;
}
</style>
